import { render } from "./NavbarDropDownItem.vue?vue&type=template&id=24288f50"
import script from "./NavbarDropDownItem.vue?vue&type=script&lang=js"
export * from "./NavbarDropDownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__